var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"RenderIndex",attrs:{"id":"webgl"}},[_c('canvas',{ref:"canvas"})]),_c('div',{staticClass:"directionPointer",staticStyle:{"display":"block"},attrs:{"id":"directionPointer"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }